import React from 'react';
import { useTranslation } from 'react-i18next';

export default function MultiValue(ctx) {
  const { t } = useTranslation();
  const selection = ctx.getValue();
  return <div>{t("count_selected", { count: selection.length })}</div>;
}
